export default "__VITE_ASSET__DjpANj1z__"